import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from 'firebase/app'
import 'firebase/auth'

// views
import ListCategoryHome from "../components/list_templates/ListCategoryHome"
import MainNavigation from "../views/MainNavigation"
import Features from "../views/Features.vue"
import SignIn from "../views/SignIn.vue"
import SignUp from "../views/SignUp.vue"
import AccountDetails from "../components/account_details/AccountDetails"
import Inbox from "../components/list_templates/Inbox"
import Important from "../components/list_templates/Important"
import Today from "../components/list_templates/Today"
import Assigned from "../components/list_templates/Assigned"
import Planned from "../components/list_templates/Planned"
import Overdue from "../components/list_templates/Overdue"
import PersonalList from "../components/list_templates/PersonalList"
import CollaborativeList from "../components/list_templates/CollaborativeList"
import CollaborativeTaskList from "../components/list_templates/CollaborativeTaskList"
import PersonalTaskList from "../components/list_templates/PersonalTaskList"
import ViewCollaborators from "../components/collaborator_templates/ViewCollaborators"
import CollaboratorDetails from "../components/collaborator_templates/CollaboratorDetails"
import TransferListOwnership from "../components/collaborator_templates/TransferListOwnership"

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Features',
    component: Features,
    meta: {
      title: 'Features | Stuff To-Do',
      metaTags: [
        {
          name: 'description',
          content: 'The features page of Stuff To-Do'
        }
      ]
    }
  },
  {
    path: '/signIn',
    name: 'Sign In',
    component: SignIn,
    meta: {
      title: 'Sign in | Stuff To-Do',
      metaTags: [
        {
          name: 'description',
          content: 'The sign in page of Stuff To-Do'
        }
      ]
    }
  },
  {
    path: '/signUp',
    name: 'Sign Up',
    component: SignUp,
    meta: {
      title: 'Sign up | Stuff To-Do',
      metaTags: [
        {
          name: 'description',
          content: 'The sign up page of Stuff To-Do'
        }
      ]
    }
  },
  {
    path: '/home',
    name: 'Home',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    components: {
      'navigation': MainNavigation,
      'related-component': ListCategoryHome
    },
    meta: {
      title: 'Home | Stuff To-Do',
      requiresAuth: true,
      metaTags: [
        {
          name: 'description',
          content: 'The home page of Stuff To-Do'
        }
      ]
    }
  },
  {
    path: '/accountDetails',
    name: 'Account Details',
    components: {
      'navigation': MainNavigation,
      'related-component': AccountDetails
    },
    meta: {
      title: 'Account Details | Stuff To-Do',
      requiresAuth: true,
      metaTags: [
        {
          name: 'description',
          content: 'The user account details page of Stuff To-Do'
        }
      ]
    }
  },
  {
    path: '/inbox',
    name: 'Inbox',
    components: {
      'navigation': MainNavigation,
      'related-component': Inbox
    },
    meta: {
      title: 'Inbox | Stuff To-Do',
      requiresAuth: true,
      metaTags: [
        {
          name: 'description',
          content: 'The inbox task page of Stuff To-Do'
        }
      ]
    }
  },
  {
    path: '/important',
    name: 'Important',
    components: {
      'navigation': MainNavigation,
      'related-component': Important
    },
    meta: {
      title: 'Important | Stuff To-Do',
      requiresAuth: true,
      metaTags: [
        {
          name: 'description',
          content: 'The important task page of Stuff To-Do'
        }
      ]
    }
  },
  {
    path: '/today',
    name: 'Today',
    components: {
      'navigation': MainNavigation,
      'related-component': Today
    },
    meta: {
      title: 'Today | Stuff To-Do',
      requiresAuth: true,
      metaTags: [
        {
          name: 'description',
          content: 'The today task page of Stuff To-Do'
        }
      ]
    }
  },
  {
    path: '/assigned',
    name: 'Assigned',
    components: {
      'navigation': MainNavigation,
      'related-component': Assigned
    },
    meta: {
      title: 'Assigned | Stuff To-Do',
      requiresAuth: true,
      metaTags: [
        {
          name: 'description',
          content: 'The assigned task page of Stuff To-Do'
        }
      ]
    }
  },
  {
    path: '/planned',
    name: 'Planned',
    components: {
      'navigation': MainNavigation,
      'related-component': Planned
    },
    meta: {
      title: 'Planned | Stuff To-Do',
      requiresAuth: true,
      metaTags: [
        {
          name: 'description',
          content: 'The planned task page of Stuff To-Do'
        }
      ]
    }
  },
  {
    path: '/overdue',
    name: 'Overdue',
    components: {
      'navigation': MainNavigation,
      'related-component': Overdue
    },
    meta: {
      title: 'Overdue | Stuff To-Do',
      requiresAuth: true,
      metaTags: [
        {
          name: 'description',
          content: 'The overdue task page of Stuff To-Do'
        }
      ]
    }
  },
  {
    path: '/personalList',
    name: 'Personal List',
    components: {
      'navigation': MainNavigation,
      'related-component': PersonalList
    },
    meta: {
      title: 'Personal List | Stuff To-Do',
      requiresAuth: true,
      metaTags: [
        {
          name: 'description',
          content: 'The personal list page of Stuff To-Do'
        }
      ]
    }
  },
  {
    path: '/collaborativeList',
    name: 'Collaborative List',
    components: {
      'navigation': MainNavigation,
      'related-component': CollaborativeList
    },
    meta: {
      title: 'Collaborative List | Stuff To-Do',
      requiresAuth: true,
      metaTags: [
        {
          name: 'description',
          content: 'The collaborative list page of Stuff To-Do'
        }
      ]
    }
  },
  {
    path: '/personalList/:personalListId',
    name: 'Personal Task List',
    components: {
      'navigation': MainNavigation,
      'related-component': PersonalTaskList
    },
    meta: {
      title: 'Personal Task List | Stuff To-Do',
      requiresAuth: true,
      metaTags: [
        {
          name: 'description',
          content: 'The personal task list page of Stuff To-Do'
        }
      ]
    }
  },
  {
    path: '/collaborativeList/:collaborativeListId',
    name: 'Collaborative Task List',
    components: {
      'navigation': MainNavigation,
      'related-component': CollaborativeTaskList
    },
    meta: {
      title: 'Collaborative Task List | Stuff To-Do',
      requiresAuth: true,
      metaTags: [
        {
          name: 'description',
          content: 'The collaborative task list page of Stuff To-Do'
        }
      ]
    }
  },
  {
    path: '/collaborativeList/:collaborativeListId/transferListOwnership',
    name: 'Transfer List Ownership',
    components: {
      'navigation': MainNavigation,
      'related-component': TransferListOwnership
    },
    meta: {
      title: 'Transfer List Ownership | Stuff To-Do',
      requiresAuth: true,
      metaTags: [
        {
          name: 'description',
          content: 'The transfer list ownership page of Stuff To-Do'
        }
      ]
    }
  },
  {
    path: '/collaborativeList/:collaborativeListId/viewCollaborators',
    name: 'View Collaborators',
    components: {
      'navigation': MainNavigation,
      'related-component': ViewCollaborators
    },
    meta: {
      title: 'View Collaborators | Stuff To-Do',
      requiresAuth: true,
      metaTags: [
        {
          name: 'description',
          content: 'The view collaborators page of Stuff To-Do'
        }
      ]
    }
  },
  {
    path: '/collaborativeList/:collaborativeListId/viewCollaborators/:collaboratorId',
    name: 'Collaborator Details',
    components: {
      'navigation': MainNavigation,
      'related-component': CollaboratorDetails
    },
    meta: {
      title: 'Collaborator Details | Stuff To-Do',
      requiresAuth: true,
      metaTags: [
        {
          name: 'description',
          content: 'The collaborator details page of Stuff To-Do'
        }
      ]
    }
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !await firebase.getCurrentUser()) {
    next('Sign In')
  } else {
    next();
  }

  if ((to.name === 'Sign In' || to.name === 'Sign Up') && await firebase.getCurrentUser()) {
    router.push('./home')
  } else {
    next()
  }

  if ((to.name !== 'Features' && to.name !== 'Sign In' && to.name !== 'Sign Up') && await firebase.getCurrentUser()) {
    if (to.name === 'Account Details') {
      router.app.$store.dispatch('updateListCategory', 'accountDetails')
    } else if (to.name === 'Home') {
      router.app.$store.dispatch('updateListCategory', 'listCategoryHome')
    } else if (to.name === 'Inbox') {
      router.app.$store.dispatch('updateListCategory', 'inbox')
    } else if (to.name === 'Important') {
      router.app.$store.dispatch('updateListCategory', 'important')
    } else if (to.name === 'Today') {
      router.app.$store.dispatch('updateListCategory', 'today')
    } else if (to.name === 'Assigned') {
      router.app.$store.dispatch('updateListCategory', 'assigned')
    } else if (to.name === 'Planned') {
      router.app.$store.dispatch('updateListCategory', 'planned')
    } else if (to.name === 'Overdue') {
      router.app.$store.dispatch('updateListCategory', 'overdue')
    } else if (to.name === 'Personal List') {
      router.app.$store.dispatch('updateListCategory', 'personalList')
    } else if (to.name === 'Collaborative List') {
      router.app.$store.dispatch('updateListCategory', 'collaborativeList')
    } else if (to.name === 'Personal Task List') {
      router.app.$store.dispatch('updateListCategory', 'personalTaskList')
    } else if (to.name === 'Collaborative Task List') {
      router.app.$store.dispatch('updateListCategory', 'collaborativeTaskList')
    } else if (to.name === 'View Collaborators') {
      router.app.$store.dispatch('updateListCategory', 'viewCollaborators')
    } else if (to.name === 'Collaborator Details') {
      router.app.$store.dispatch('updateListCategory', 'collaboratorDetails')
    }
  }

  router.app.$root.$emit('bv::hide::modal', 'list-option-modal')
  router.app.$root.$emit('bv::hide::modal', 'task-list-option-modal')
  router.app.$root.$emit('bv::hide::modal', 'creation-modal')
  router.app.$root.$emit('bv::hide::modal', 'collaborator-option-modal')
});

// set the title of the page
const DEFAULT_TITLE = 'Stuff To-Do';
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE
  });
});

export default router
